import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenNib,
  faLaptopCode,
  faMagnifyingGlass,
  faRocket,
  faShareNodes,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: "ui-ux-design",
      icon: faPenNib,
      title: "UI / UX & Website Design",
      desc:
        "We design clear, intuitive interfaces that feel natural to use and communicate trust from the first interaction.",
    },
    {
      id: "web-development",
      icon: faLaptopCode,
      title: "Website & App Development",
      desc:
        "Our development focuses on performance, accessibility, and maintainability—so your product works reliably as you grow.",
    },
    {
      id: "search-engine-optimization",
      icon: faMagnifyingGlass,
      title: "SEO & Search Visibility",
      desc:
        "We improve structure, content clarity, and technical foundations to help search engines understand and rank your site.",
    },
    {
      id: "social-media-marketing",
      icon: faShareNodes,
      title: "Social Media Marketing",
      desc:
        "Thoughtful content and consistent messaging that strengthens brand presence and builds long-term engagement.",
    },
    {
      id: "search-engine-marketing",
      icon: faRocket,
      title: "Paid Ads & Lead Generation",
      desc:
        "We create focused ad campaigns built on clarity, testing, and measurable outcomes—not guesswork.",
    },
    {
      id: "local-business-growth",
      icon: faLocationDot,
      title: "Local Business Growth",
      desc:
        "Optimizing local visibility so nearby customers can easily find, trust, and contact your business.",
    },
  ];

  return (
    <section className="about-services" aria-label="Our services">
      <div className="about-services-wrap">
        {/* Header */}
        <header className="about-services-head">
          <h2>What we help you with</h2>
          <p>
            Our services are designed to support your business at every stage —
            from clarity and structure to growth and long-term stability.
          </p>
        </header>

        {/* Services list */}
        <div className="about-services-list">
          {services.map((s) => (
            <article
              key={s.id}
              className="about-services-item"
              onClick={() => navigate(`/services/${s.id}`)}
              tabIndex={0}
              role="button"
            >
              <div className="about-services-icon">
                <FontAwesomeIcon icon={s.icon} />
              </div>

              <div className="about-services-content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
